'use strict';

import { doFetch } from '../../utils/CommonUtils';
import Routes from '../../utils/Routes';
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import Constants from '../Constants';

const ChangeEvent = 'BreadCrumb';

const ChangeEvents = {
	breadcrumb: ChangeEvent,
};

const breadcrumbs = {};

const getAlbumId = (breadcrumbs) => {
	const videoBreadcrumb = breadcrumbs.find((breadcrumb) => breadcrumb.type === 'VideoObject');
	if (videoBreadcrumb) {
		const url = videoBreadcrumb.url;
		return url.split('/videos/')[1]?.split('-')[0];
	}
};

const BreadcrumbStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: ChangeEvents,

	getBreadcrumb: function (key) {
		return breadcrumbs[key];
	},

	loadBreadcrumb: function (breadcrumbType, payload, breadcrumbKey) {
		if (breadcrumbs[breadcrumbKey] && (payload.albumId === 0 || (payload.albumId && payload.albumId === getAlbumId(breadcrumbs[breadcrumbKey])))) {
			this.emit(ChangeEvent, breadcrumbType, breadcrumbKey);
		} else {
			doFetch(Routes.getRoute(Routes.Names.BREADCRUMB, { breadcrumbType }), { payload }, Constants.HttpMethods.POST, true).then((data) => {
				breadcrumbs[breadcrumbKey] = data.data.breadcrumb;
				this.emit(ChangeEvent, breadcrumbType, breadcrumbKey);
			});
		}
	},
});

export default BreadcrumbStore;
